// Modal.js
import React from "react";
import "../App.css";

const Modal = ({ isOpen, title, message, onClose, onConfirm, type = "info" }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">{title}</h2>
        <p className="modal-message">{message}</p>
        <div className="modal-buttons">
          {type === "confirmation" ? (
            <>
              <button onClick={onClose} className="modal-button cancel-button">
                Cancel
              </button>
              <button onClick={onConfirm} className="modal-button confirm-button">
                Confirm
              </button>
            </>
          ) : (
            <button onClick={onClose} className="modal-button">
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
